export const SHOW_ME_HOW = "Show Me How";
export const SHOW_ME_TIPS = "Show Me Tips";

export const gtmEventNames = {
  SAVE_SCORE: "SaveScore",
  SAVE_ACTION_PLAN: "SubmitPlanForm",
  TRACK_DFD_EVENT: "DFDDataTracking",
  SHOW_ME_HOW: "ResultData",
  CLICK: "Click",
  TRACK_ACTIVITIES: "SelectedActivity"
};

export const gtmActionNames = {
  RESULTS: "results"
};

export const gtmClickIds = {
  SHOW_ME_HOW: "ShowMeHow",
  SHOW_ME_TIPS: "ShowMeTips"
};
